__turbopack_context__.v({
  "className": "eb_garamond_f876b6f2-module__DlJoXG__className",
});
